/* eslint-disable jsx-a11y/no-static-element-interactions, react/prop-types */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import fetchTrackerTransactions from './action-trackers';
import trackerRules from './trackerAlertRules';
import Page from '../../lib/page';
import RefundAlert from './RefundAlert';
import { getFinalTransactions, isCsHelpRefundTrackerEnabled } from '../../lib/TrackersHelper';

class TrackerAlerts extends Component {
  componentWillMount() {
    this.props.fetchTrackerTransactions();
  }

  // ------------------------------------------- REFUND ALERT LOGIC-----------------------------------------

  // Display refunds alert only in the whitelisted paths.
  isDisplayRefundAlertPath() {
    const { pathName } = this.props;
    if (Page.isContactUsPage()) {
      return this.props.topicsLayer === 1;
    }
    return trackerRules.refunds.whitelistedPaths.includes(pathName);
  }

  // Common method to determine to display refund alert or not. These are flow of conditions which are checked to display refunds alert.
  // 1) check if refunds tracker is enabled in RC.
  // 2) Check if current path is enabled to display alert
  // 3) check if final transactions length is greater than 0.
  // Refund alert will be displayed only if all the above 3 conditions are met.
  isDisplayRefundAlert() {
    const { transactions, configs } = this.props;
    return (
      isCsHelpRefundTrackerEnabled() &&
      this.isDisplayRefundAlertPath() &&
      getFinalTransactions(transactions, configs).length > 0
    );
  }

  // Render refunds alert
  renderRefundAlert() {
    const { transactions, pathName } = this.props;

    // If all the conditions are true then display refunds alert.
    if (this.isDisplayRefundAlert()) {
      return <RefundAlert transactions={transactions} pathName={pathName} />;
    }

    return <div />;
  }

  // ---------------------------------- END OF REFUND ALERT ---------------------------------------

  renderTrackerAlerts() {
    const { transactions } = this.props;

    if (Array.isArray(transactions) && transactions.length > 0) {
      return <div className="alert-container">{this.renderRefundAlert()}</div>;
    }

    return null;
  }

  render() {
    return this.renderTrackerAlerts();
  }
}

TrackerAlerts.defaultProps = {
  transactions: [],
  configs: {},
  topicsLayer: null,
  pathName: '',
};

const mapStateToProps = (state) => ({
  transactions: state.trackers.transactions,
  configs: state.trackers.configs,
  error: state.trackers.error,
  isLoading: state.trackers.isLoading,
  topicsLayer: (state.topicSelect || {}).layer || null,
  pathName: state.location.pathname || state.location.pageName,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ fetchTrackerTransactions }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TrackerAlerts);
